import TableRow from "@mui/material/TableRow";
import { Box, Chip } from "@mui/material";
import { dateFormat, formatMoney } from "../../../common/utils";
import PayPal from "../images/paypal.png";
import Venmo from "../images/venmo.png";
import { LiParagraph, LiTableCell } from "../components/pieces";
import { ClickableText } from "../components/Typography";
import type { Payout, AppContext } from "../../../types";

interface PayoutTableRowProps {
    payout: Payout;
    context: AppContext;
    onClick: (payout: Payout) => void;
    openGCard: (payout: Payout) => void;
}

const PayoutTableRow = ({ payout, context, onClick, openGCard }: PayoutTableRowProps) => {
    const images: Record<string, string> = {
        paypal: PayPal,
        venmo: Venmo,
    };

    const brandNames: Record<string, string> = {
        paypal: `PayPal`,
        venmo: `Venmo`,
    };

    const chipMap: Record<string, "success" | "error" | "info" | "warning"> = {
        Sent: `success`,
        Completed: `success`,
        Returned: `error`,
        Canceled: `error`,
        Requested: `info`,
        Mailed: `success`,
        "In Process": `warning`,
    };

    return (
        <TableRow sx={{ border: `none`, borderTop: `1px solid #E1E1E1` }}>
            <LiTableCell sx={{ textAlign: `left`, padding: `16px 16px 16px 28px`, maxWidth: 80 }}>
                <LiParagraph>
                    {dateFormat(payout[`Payout Date`] || payout.awardSelectedTs || context.nextFifteen)}
                </LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `left`, padding: `16px 0 16px 28px`, width: `35px` }}>
                <Box
                    sx={{
                        maxHeight: images[payout[`Payout Type`]] ? 30 : 35,
                        height: `auto`,
                        maxWidth: 40,
                        width: `auto`,
                        marginRight: `10px`,
                        verticalAlign: `middle`,
                    }}
                    component="img"
                    src={images[payout[`Payout Type`]] || payout.icon || payout.logo}
                />
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `left`, padding: `16px 16px 16px 0 ` }}>
                <LiParagraph>
                    {brandNames[payout[`Payout Type`]] || payout[`Payout Type`] || `${payout.brandName} Gift Card`}
                </LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `right`, padding: `16px 28px 16px 16px` }}>
                <LiParagraph>{formatMoney((payout[`Payout Amount`] || payout.awardAmount) as number)}</LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `center`, padding: `24px 28px 24px 24px`, width: 80 }}>
                <Box
                    sx={{
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: `center`,
                    }}
                >
                    {payout.delivery === `mail` ? (
                        <Chip
                            sx={{ padding: `1px 8px 0` }}
                            size="small"
                            label={payout[`Payout Status`] || "Mailed"}
                            color={chipMap[payout[`Payout Status`]] ?? `error`}
                        />
                    ) : payout[`Payout Status`] === `Completed` ? (
                        <ClickableText onClick={() => openGCard(payout)}>View My Card</ClickableText>
                    ) : (
                        <Chip
                            sx={{ padding: `1px 8px 0` }}
                            size="small"
                            label={payout[`Payout Status`]}
                            color={chipMap[payout[`Payout Status`]] ?? `error`}
                        />
                    )}
                </Box>
            </LiTableCell>
            {context?.adminConfig!.mall!.CORE_SETTINGS![`Payout Method`] === `Request` && (
                <LiTableCell sx={{ maxWidth: `65px` }}>
                    <LiParagraph>
                        {payout[`Payout Status`] === `Requested` && payout.cancelId && (
                            <ClickableText onClick={() => onClick(payout)}>Cancel</ClickableText>
                        )}
                    </LiParagraph>
                </LiTableCell>
            )}
        </TableRow>
    );
};

export default PayoutTableRow;
